import createUICardElement from "backend/utils/createUICardElement";
import * as wf from "client-api-workflow";
import { useQuery } from "react-query";

const useWorkflowLogs = (id?: string) => {
  return useQuery(
    JSON.stringify(["data-workflow-logs", id]),
    () => {
      return wf.getLogs(id || "").then((list) => {
        return list.map((data) =>
          createUICardElement(data.timestamp, "logentry", data)
        );
      });
    },
    {
      enabled: !!id,
      cacheTime: 1 * 1000,
    }
  );
};

export default useWorkflowLogs;
